import TColorPicker from './color-picker.vue'

TColorPicker.install = Vue => {
  Vue.component(TColorPicker.name, TColorPicker)
}

export default TColorPicker



// WEBPACK FOOTER //
// ./src/module/color-picker/index.js